import { type Layout } from '@/layouts';
import { NavMenuKeys } from '@/routes/navMenu';
import { RouteObject } from 'react-router-dom';
import { pageRoutes } from './routes';

export type Route = {
  // breadcrumb?: boolean; //是否展示在当前页面展示面包屑
  // hideInMenu?: boolean; //是否在菜单中隐藏
  enable?: boolean;
  icon?: JSX.Element; // 路由图标，用于菜单以及面包屑导航
  name?: string; // 路由名称
  module?: NavMenuKeys; // 对应的模块
  children?: Route[];
  layout?: Layout; // 采用的布局
  auth?: boolean; // 是否需要认证才能访问
  guest?: boolean; // 是否客人身份才能访问
  order?: number;
} & RouteObject;

export const routes: Route[] = pageRoutes;
